import React, { useEffect, useState } from 'react';
import { FormControl, Grid, MenuItem, Paper, Select } from '@mui/material';
import { styled } from '@mui/system'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import Loader from '../../components/Loader/Loader'
import Toptag from '../../components/toptag/Toptag'
import apiFunctions from '../../api/apiFunctions'
import "./networks.css"

const NavPaper = styled(Paper)({
    padding: "5px 12px",
    borderRadius: "0",
    backgroundColor: "white",
    boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px"
})

export default function AddEditNetwork() {
    const location = useLocation();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [err, setErr] = useState(false);
    const isEdit = location.state?.id ? true : false;
    const networkId = location.state?.id;

    const [obj, setObj] = useState({
        name: '',
        chain_id: '',
        native_currency_symbol: 'ETH',
        is_active: true,
        network_type: 'mainnet',
        supported_tokens: [{ symbol: 'USDC', is_default: true, coingecko_id: 'usd-coin' }]
    })

    useEffect(() => {
        if (isEdit && networkId) {
            getNetworkDetail();
        } else {
            setIsLoading(false);
        }
    }, [isEdit, networkId])

    const getNetworkDetail = async () => {
        setIsLoading(true);
        try {
            const result = await apiFunctions.getNetwork(networkId);
            if (!result.data.status) {
                if (result.data.code === 401) {
                    localStorage.clear();
                    navigate("/login")
                    toast.info("Session Expired Please login again!!")
                }
                toast.error(result.data.message, {
                    position: toast.POSITION.TOP_RIGHT
                });
                navigate("/home/networks");
            } else {
                setObj({
                    _id: result.data.data._id,
                    name: result.data.data.name,
                    chain_id: result.data.data.chain_id,
                    native_currency_symbol: result.data.data.native_currency_symbol,
                    is_active: result.data.data.is_active,
                    network_type: result.data.data.network_type,
                    supported_tokens: result.data.data.supported_tokens?.length
                        ? result.data.data.supported_tokens
                        : [{ symbol: 'USDC', is_default: true, coingecko_id: 'usd-coin' }]
                });
            }
        } catch (error) {
            toast.error("Something went wrong while loading the network!", {
                position: toast.POSITION.TOP_RIGHT
            });
            navigate("/home/networks");
        } finally {
            setIsLoading(false);
        }
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        setErr(false);

        if (!obj.name || !obj.chain_id) {
            setErr(true);
            return;
        }

        let networkObj = {
            name: obj.name,
            chain_id: parseInt(obj.chain_id),
            native_currency_symbol: obj.native_currency_symbol || 'ETH',
            is_active: obj.is_active,
            network_type: obj.network_type || 'mainnet',
            supported_tokens: (obj.supported_tokens || []).map((token, index) => ({
                symbol: (token.symbol || '').trim().toUpperCase(),
                is_default: index === 0 ? true : !!token.is_default,
                coingecko_id: (token.coingecko_id || '').trim()
            }))
        }

        let result;
        if (isEdit) {
            result = await apiFunctions.updateNetwork(obj._id, networkObj);
        } else {
            result = await apiFunctions.createNetwork(networkObj);
        }

        if (!result.data.status) {
            if (result.data.code === 401) {
                localStorage.clear();
                navigate("/login")
                toast.info("Session Expired Please login again!!")
            }
            toast.error(result.data.message, {
                position: toast.POSITION.TOP_RIGHT
            });
        } else {
            toast.success(isEdit ? "Network updated successfully!" : "Network created successfully!")
            setTimeout(() => {
                navigate("/home/networks");
            }, 1000);
        }
    };

    const addNetworkData = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === 'checkbox') {
            setObj({
                ...obj,
                [name]: checked,
            });
        } else {
            setObj({
                ...obj,
                [name]: value,
            });
        }
    }

    return (
        <>
            <div className='container'>
                {isLoading ? (
                    <Loader />
                ) : (
                    <>
                        <Toptag />
                        <ToastContainer autoClose={1000} />
                        <NavPaper>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <div className='popHeading'>{isEdit ? 'Edit Network' : 'Create New Network'}</div>
                            </div>
                            
                            <form onSubmit={handleSubmit}>
                                <div style={{ display: "flex", justifyContent: "start", gap: "30px", alignItems: "start", flexWrap: "wrap", padding: "20px" }}>
                                    <div style={{ flex: "1", minWidth: "300px" }}>
                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", gap: "10px", alignItems: "flex-start" }}>
                                            <div className="popText">Network Name *</div>
                                            <div style={{ width: "100%" }}><input type="text" className="popInput" name="name" id="name" value={obj.name} onChange={addNetworkData} placeholder="Ethereum" style={{ width: "100%", maxWidth: "100%" }} /></div>
                                            {err && obj.name === '' ? <div className="errText">Name is required!</div> : null}
                                        </div>
                                    </div>

                                    <div style={{ flex: "1", minWidth: "300px" }}>
                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", gap: "10px", alignItems: "flex-start" }}>
                                            <div className="popText">Chain ID *</div>
                                            <div style={{ width: "100%" }}><input type="number" className="popInput" name="chain_id" id="chain_id" value={obj.chain_id} onChange={addNetworkData} placeholder="1" style={{ width: "100%", maxWidth: "100%" }} /></div>
                                            {err && obj.chain_id === '' ? <div className="errText">Chain ID is required!</div> : null}
                                        </div>
                                    </div>
                                </div>

                                <div style={{ display: "flex", justifyContent: "start", gap: "30px", alignItems: "start", flexWrap: "wrap", padding: "0 20px 20px 20px" }}>
                                    <div style={{ flex: "1", minWidth: "300px" }}>
                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", gap: "10px", alignItems: "flex-start" }}>
                                            <div className="popText">Native Currency Symbol</div>
                                            <div style={{ width: "100%" }}><input type="text" className="popInput" name="native_currency_symbol" id="native_currency_symbol" value={obj.native_currency_symbol} onChange={addNetworkData} placeholder="ETH" style={{ width: "100%", maxWidth: "100%" }} /></div>
                                        </div>
                                    </div>

                                    <div style={{ flex: "1", minWidth: "300px" }}>
                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", gap: "10px", alignItems: "flex-start" }}>
                                            <div className="popText">Network Type</div>
                                            <FormControl variant="standard" sx={{ minWidth: "100%", maxWidth: "540px" }}>
                                                <Select
                                                    name="network_type"
                                                    value={obj.network_type}
                                                    onChange={addNetworkData}
                                                >
                                                    <MenuItem value="mainnet">Mainnet</MenuItem>
                                                    <MenuItem value="testnet">Testnet</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </div>
                                </div>

                                <div style={{ display: "flex", justifyContent: "start", gap: "30px", alignItems: "start", padding: "0 20px 20px 20px" }}>
                                    <div style={{ flex: "1", minWidth: "300px" }}>
                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", gap: "10px", alignItems: "flex-start" }}>
                                            <div className="popText">Status</div>
                                            <FormControl variant="standard" sx={{ minWidth: 200, maxWidth: "540px" }}>
                                                <Select
                                                    name="is_active"
                                                    value={obj.is_active}
                                                    onChange={(e) => {
                                                        setObj({
                                                            ...obj,
                                                            is_active: e.target.value === 'true'
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value={true}>Active</MenuItem>
                                                    <MenuItem value={false}>Inactive</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </div>
                                </div>

                                <div style={{ padding: "0 20px 20px 20px" }}>
                                    <div className="popText" style={{ marginBottom: "6px" }}>Supported Payout Tokens</div>
                                    <div style={{ fontSize: "13px", color: "#666", marginBottom: "12px", lineHeight: 1.5, maxWidth: "720px" }}>
                                        CoinGecko ID is used to fetch live USD prices for payout conversion.
                                        To find it: open{' '}
                                        <a
                                            href="https://www.coingecko.com"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ color: "#1976d2" }}
                                        >
                                            coingecko.com
                                        </a>
                                        , search the token, open its page — the ID is the last part of the URL
                                        (e.g. <code>coingecko.com/en/coins/usd-coin</code> → <code>usd-coin</code>).
                                        Common: USDC = <code>usd-coin</code>, ETH = <code>ethereum</code>, POL = <code>polygon-ecosystem-token</code>.
                                    </div>
                                    {(obj.supported_tokens || []).map((token, index) => (
                                        <div key={index} style={{ display: "flex", gap: "10px", marginBottom: "10px", flexWrap: "wrap", alignItems: "center" }}>
                                            <input
                                                className="popInput"
                                                placeholder="Symbol (USDC)"
                                                value={token.symbol || ''}
                                                onChange={(e) => {
                                                    const next = [...obj.supported_tokens];
                                                    next[index] = { ...next[index], symbol: e.target.value };
                                                    setObj({ ...obj, supported_tokens: next });
                                                }}
                                            />
                                            <input
                                                className="popInput"
                                                placeholder="CoinGecko ID (usd-coin)"
                                                value={token.coingecko_id || ''}
                                                onChange={(e) => {
                                                    const next = [...obj.supported_tokens];
                                                    next[index] = { ...next[index], coingecko_id: e.target.value };
                                                    setObj({ ...obj, supported_tokens: next });
                                                }}
                                                title="From CoinGecko coin page URL, e.g. usd-coin"
                                            />
                                        </div>
                                    ))}
                                </div>

                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "15px", marginBottom: "15px", gap: "15px" }}>
                                    <button type="button" className='popBtn' style={{ backgroundColor: "#6c757d", color: "white", marginRight: "10px" }} onClick={() => navigate("/home/networks")}>
                                        CANCEL
                                    </button>
                                    <button type="submit" className='popBtn'>
                                        {isEdit ? 'UPDATE' : 'CREATE'}
                                    </button>
                                </div>
                            </form>
                        </NavPaper>
                    </>
                )}
            </div>
        </>
    )
}
